import { defineKey as T } from '@ha/intl';

import Tenant1 from 'img-src/home/tenant-1.svg';
import Tenant2 from 'img-src/home/tenant-2.svg';
import Tenant3 from 'img-src/home/tenant-3.svg';
import Landlord1 from 'img-src/home/landlord-1.svg';
import Landlord2 from 'img-src/home/landlord-2.svg';
import Landlord3 from 'img-src/home/landlord-3.svg';

export const tenantVps = [
  {
    icon: Tenant1,
    title: T('home_vp_tenant_title_1'),
    text: T('home_vp_tenant_text_1'),
  },
  {
    icon: Tenant2,
    title: T('home_vp_tenant_title_2'),
    text: T('home_vp_tenant_text_2'),
  },
  {
    icon: Tenant3,
    title: T('home_vp_tenant_title_3'),
    text: T('home_vp_tenant_text_3'),
  },
];

export const landlordVps = [
  {
    icon: Landlord1,
    title: T('home_vp_landlord_title_1'),
    text: T('home_vp_landlord_text_1'),
  },
  {
    icon: Landlord2,
    title: T('home_vp_landlord_title_2'),
    text: T('home_vp_landlord_text_2'),
  },
  {
    icon: Landlord3,
    title: T('home_vp_landlord_title_3'),
    text: T('home_vp_landlord_text_3'),
  },
];
